import React, { useState, useEffect } from "react";
import { Download, Smartphone, Share, Plus, X } from "lucide-react";
import { canInstall, promptInstall, onInstallChange, isStandalone, isIOS } from "@/lib/pwa";

export default function InstallButton({ className = "", label = "Uygulamayı Ekle", compact = false }) {
  const [available, setAvailable] = useState(canInstall());
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => onInstallChange(setAvailable), []);

  if (isStandalone()) return null;

  const handle = async () => {
    if (available) {
      const outcome = await promptInstall();
      if (outcome === "unavailable") setShowHelp(true);
    } else {
      setShowHelp(true);
    }
  };

  return (
    <>
      <button
        data-testid="install-app-btn"
        onClick={handle}
        className={className || `inline-flex items-center gap-2 bg-amber-400 hover:bg-amber-300 text-indigo-900 font-bold rounded-full px-4 py-2 text-sm transition-colors ${compact ? "" : "shadow-sm"}`}
      >
        <Smartphone className="w-4 h-4" /> {label}
      </button>

      {showHelp && (
        <div className="fixed inset-0 z-[80] bg-black/50 flex items-end sm:items-center justify-center p-4" onClick={() => setShowHelp(false)}>
          <div data-testid="install-help-modal" className="bg-white rounded-3xl p-6 max-w-sm w-full animate-float-up" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start">
              <div className="text-4xl">📲</div>
              <button onClick={() => setShowHelp(false)} className="text-slate-400 hover:text-slate-700"><X className="w-5 h-5" /></button>
            </div>
            <h3 className="font-display text-xl font-bold text-slate-900 mt-2">NoktaDers'i cihazına ekle</h3>
            {isIOS() ? (
              <ol className="mt-4 space-y-3 text-sm text-slate-600">
                <li className="flex items-center gap-2"><Share className="w-5 h-5 text-indigo-600" /> Safari'de alttaki <b>Paylaş</b> düğmesine bas</li>
                <li className="flex items-center gap-2"><Plus className="w-5 h-5 text-indigo-600" /> <b>Ana Ekrana Ekle</b> seçeneğini seç</li>
                <li className="flex items-center gap-2"><Download className="w-5 h-5 text-indigo-600" /> <b>Ekle</b>'ye dokun — hazır! 🎉</li>
              </ol>
            ) : (
              <ol className="mt-4 space-y-3 text-sm text-slate-600">
                <li>1. Tarayıcının adres çubuğundaki <b>yükleme (⊕)</b> simgesine tıkla</li>
                <li>2. Menüden <b>"Uygulamayı yükle"</b> seçeneğini seç</li>
                <li>3. Onayla — NoktaDers artık bir uygulama gibi açılır! 🎉</li>
              </ol>
            )}
            <p className="text-xs text-slate-400 mt-4">Not: Bazı tarayıcılar otomatik yükleme desteklemez, bu durumda yukarıdaki adımları izle.</p>
          </div>
        </div>
      )}
    </>
  );
}
